import React, { useContext, useEffect, useState } from "react";
import "./DashboardHeader.css";
import logo from "../../assests/BEMSS1.png";
import { AuthContext } from "../../context/AuthContext";
import logo_img from "../../assests/user_acccount_logo.png";
import { useNavigate } from "react-router-dom";
import attendance_logo from "../../assests/attendance-logo.png"
import axios from "axios";
import BirthDayTemplate from "../BirthDayTemplate";
import Confetti from "react-confetti";
import WeddingAnniversary from "../WeddingAnniversary"
import WorkAnniversary from "../WorkAnniversary";
import ThoughtTemplate from "../../assests/thought.png"
import NotificationBar from "../../pages/NotificationBar";
import { Card, Typography, Spin } from "antd";

const { Title, Text } = Typography;

export default function DashboardHeader() {
    const { authData, logout, backUrl } = useContext(AuthContext);

    const [attendanceLoading, setAttendanceLoading] = useState(false);

    const [masterData, setMasterData] = useState(null);
    const [isEmployeeView, setIsEmployeeView] = useState(
        localStorage.getItem("Hrselected") === "employee"
    );
    const navigate = useNavigate();
    const isMobile = window.innerWidth < 768;
    const [showConfetti, setShowConfetti] = useState(false);
    const [showThought, setShowThought] = useState(false);
    const [thought, setThought] = useState("");
    const [isWeddingDay, setIsWeddingDay] = useState(false);
    const [isBirthDay, setIsBirthDay] = useState(false);
    const [showBirthdayCard, setShowBirthdayCard] = useState(false);
    const [isWorkAnniversary, setIsWorkAnniversary] = useState(false);
    const [isNoRecord, setIsNoRecord] = useState(false);

    useEffect(() => {
        const thoughts = [
            "Success is the sum of small efforts repeated day in and day out.",
            "Stay positive, work hard, and make it happen.",
            "Your limitation—it's only your imagination.",
            "Great things never come from comfort zones.",
            "Push yourself, because no one else is going to do it for you."
        ];

        const randomThought = thoughts[Math.floor(Math.random() * thoughts.length)];
        setThought(randomThought);
        if (authData?.thought_for_the_day === 1) {
            setShowThought(true);
        }
        const hideTimer = setTimeout(() => {
            setShowThought(false);
        }, 5000);

        return () => clearTimeout(hideTimer);
    }, []);

    useEffect(() => {
        if (authData?.is_wedding_today) {
            setIsWeddingDay(true)
        }
        if (authData?.is_birthday_today) {
            setIsBirthDay(true)
        }
        if (authData?.is_work_anniversary_today) {
            setIsWorkAnniversary(true)
        }
    }, [authData])

    useEffect(() => {
        if (isBirthDay || isWeddingDay || isWorkAnniversary) {
            const showTimer = setTimeout(() => {
                setShowBirthdayCard(true);
                setShowConfetti(true);

                setTimeout(() => setShowConfetti(false), 5000);
                setTimeout(() => setShowBirthdayCard(false), 6000);
            }, 4000);
            return () => clearTimeout(showTimer);
        }
    }, [isBirthDay, isWeddingDay, isWorkAnniversary]);

    const handleLogout = async () => {
        await logout();
        window.location.href = "/";
    };

    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/hr/attendance/today`, {
                headers: { Authorization: `Bearer ${authData.access}` },
            });
            setMasterData(res.data);
            setIsNoRecord(true)
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [])

    const handleToggle = () => {
        const current = localStorage.getItem("Hrselected");

        if (current === "hr") {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        } else if (current === "payroll") {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        } else if (current === "employee") {
            if (authData?.employee?.is_superuser) {
                localStorage.setItem("Hrselected", "hr");
                navigate("/hrdashboard");
            } else if (authData?.employee?.is_hr && authData?.employee?.role === 2) {
                localStorage.setItem("Hrselected", "payroll");
                navigate("/payroll_hr");
            }
            else if (authData?.employee?.is_hr && authData?.employee?.role === 1) {
                localStorage.setItem("Hrselected", "onboard");
                navigate("/payroll_hr");
            } else {
                localStorage.setItem("Hrselected", "employee");
                navigate("/employee");
            }
        } else {
            localStorage.setItem("Hrselected", "employee");
            navigate("/employee");
        }
    };

    const handlePassword = async () => {
        navigate("/change_password");
    }

    const handleAttendanceClick = async () => {
        try {
            setAttendanceLoading(true);

            const getLocationPermission = () =>
                new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(
                        (pos) => resolve(pos),
                        (err) => reject(err)
                    );
                });

            const getCameraPermission = async () => {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach(track => track.stop());
            };

            await getLocationPermission();
            await getCameraPermission();

            navigate("/attendance");

        } catch (error) {
            console.error("Permission denied:", error);
            alert("Location and Camera permissions are required for attendance.");
        } finally {
            setAttendanceLoading(false);
        }
    };


    return (
        <header className="loginheader d-flex align-items-center justify-content-between px-4 py-2">
            {isMobile ? (
                <img src={logo} style={{ width: '150px', height: '40px' }} alt="App Logo" className="logo" />
            ) : (
                <img style={{ width: '150px' }} src={logo} alt="App Logo" className="logo" />
            )}

            <section className="d-flex align-items-center">
                {authData?.employee?.is_checkin && (
                    <div className="attendance-wrapper">
                        {isMobile ? (
                            <>
                                <Spin spinning={attendanceLoading} size="small">
                                    <img
                                        onClick={!attendanceLoading ? handleAttendanceClick : undefined}
                                        src={attendance_logo}
                                        alt="attendance"
                                        className={`${!isNoRecord ? "pulse-border" : "static-border"} attendance-icon`}
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            cursor: attendanceLoading ? "not-allowed" : "pointer",
                                            maxWidth: "100%",
                                            border: isNoRecord ? "5px solid green" : "2px solid red",
                                            borderRadius: "50%",
                                            opacity: attendanceLoading ? 0.5 : 1,
                                            transition: "opacity 0.2s",
                                            marginRight: "20px",
                                        }}
                                    />
                                </Spin>

                            </>
                        ) : (
                            <>
                                <Spin spinning={attendanceLoading}>
                                    <img
                                        onClick={!attendanceLoading ? handleAttendanceClick : undefined}
                                        src={attendance_logo}
                                        alt="attendance"
                                        className={`${!isNoRecord ? "pulse-border" : "static-border"} attendance-icon`}
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            cursor: attendanceLoading ? "not-allowed" : "pointer",
                                            maxWidth: "100%",
                                            border: isNoRecord ? "5px solid green" : "2px solid red",
                                            borderRadius: "50%",
                                            opacity: attendanceLoading ? 0.5 : 1,
                                            transition: "opacity 0.2s",
                                            marginRight: "100px",
                                        }}
                                    />
                                </Spin>

                            </>
                        )}
                        <span className="attendance-label">Attendance</span>

                    </div>
                )}


                {authData?.employee?.is_hr === true && (
                    <div
                        onClick={handleToggle}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginRight: "20px",
                            cursor: "pointer",
                            userSelect: "none",
                        }}
                    >
                        <div
                            style={{
                                width: isMobile ? "100px" : "150px",
                                height: "34px",
                                backgroundColor: isEmployeeView ? "#0e497b" : "#16a34a",
                                borderRadius: "50px",
                                position: "relative",
                                transition: "background-color 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: isEmployeeView ? "flex-start" : "flex-end",
                                padding: "0 6px",
                            }}
                        >
                            <div
                                style={{
                                    width: "26px",
                                    height: "26px",
                                    backgroundColor: "#fff",
                                    borderRadius: "50%",
                                    transition: "all 0.3s ease",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                                }}
                            />
                            <span
                                style={{
                                    position: "absolute",
                                    left: isEmployeeView ? "40px" : "10px",
                                    right: isEmployeeView ? "10px" : "40px",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    transition: "all 0.3s ease",
                                }}
                            >
                                {isEmployeeView ? "Employee View" : "HR View"}
                            </span>
                        </div>
                    </div>
                )}

                <div className="dropdown me-3 d-flex">
                    <div
                        className="d-flex flex-column dropdown-toggle account-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <small>Your Account</small>
                        <center>
                            <strong>
                                {authData?.employee?.initial || " "}{"  "}
                                {authData?.employee?.first_name}{" "}
                                {authData?.employee?.last_name}{" "}
                                {authData?.employee?.surname}{" "}
                            </strong>
                            {!isMobile && (
                                <img id="logo-img" src={logo_img} alt="Logo" />
                            )}
                        </center>
                    </div>
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li>
                            <button className="dropdown-item" onClick={handlePassword}>Change Password</button>
                        </li>
                        <li>
                            <button
                                className="dropdown-item text-danger"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </li>
                    </ul>
                    <NotificationBar backUrl={backUrl} authData={authData} />
                </div>
            </section>

            {(isWeddingDay || isBirthDay || isWorkAnniversary) && showBirthdayCard && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        animation: "fadeIn 0.5s ease",
                    }}
                    onClick={() => setShowBirthdayCard(false)}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: "30px",
                            zIndex: 10000,
                            animation: "popIn 0.6s ease",
                        }}
                    >
                        {isBirthDay && (
                            <div className="hanging-animation">
                                <BirthDayTemplate employee={authData?.employee} />
                            </div>
                        )}

                        {isWeddingDay && (
                            <div className="hanging-animation">
                                <WeddingAnniversary employee={authData?.employee} type="wedding" />
                            </div>
                        )}

                        {isWorkAnniversary && (
                            <div className="hanging-animation">
                                <WorkAnniversary employee={authData?.employee} type="anniversary" />
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showConfetti && (
                <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    numberOfPieces={250}
                    gravity={0.3}
                    recycle={false}
                />
            )}

            {showThought && (
                <div
                    style={{
                        position: "fixed",
                        top: isMobile ? 70 : 80,
                        right: isMobile ? 10 : 30,
                        width: isMobile ? "92%" : 320,
                        height: isMobile ? 190 : 210,
                        zIndex: 9999,
                        animation: "fadeInOut 5s ease forwards",
                    }}
                >
                    <Card
                        bordered={false}
                        style={{
                            height: "100%",
                            borderRadius: 18,
                            overflow: "hidden",
                            backgroundImage: `url(${ThoughtTemplate})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                            backdropFilter: "blur(6px)",
                            border: "1px solid rgba(14,73,123,0.4)",
                        }}
                        bodyStyle={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "20px",
                            background: "rgba(255,255,255,0.65)", // glass overlay
                        }}
                    >
                        {/* Title */}
                        <Title
                            level={5}
                            style={{
                                marginBottom: 12,
                                fontStyle: "italic",
                                color: "#0e497b",
                            }}
                        >
                            🌞 Thought for the Day
                        </Title>

                        {/* Thought Text */}
                        <Text
                            style={{
                                fontSize: 15,
                                lineHeight: 1.6,
                                color: "#063970",
                                fontStyle: "italic",
                                maxWidth: "85%",
                            }}
                        >
                            "{thought}"
                        </Text>
                    </Card>
                </div>
            )}
        </header>
    );
}